import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import './ScrollToTop.css';

const ScrollToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);

  const handleScroll = () => {
    // 1. Sprawdzanie czy pokazać przycisk (po 900px scrolla)
    if (window.pageYOffset > 900) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }

    // 2. Sprawdzanie czy jesteśmy przy samym dole strony (stopka)
    // Bezpieczny margines 150px pozwala przyciskowi zatrzymać się, zanim najedzie na tekst
    const scrollPosition = window.innerHeight + window.pageYOffset;
    const documentHeight = document.documentElement.offsetHeight;
    
    if (documentHeight - scrollPosition < 150) {
      setIsAtBottom(true);
    } else {
      setIsAtBottom(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    // Wywołanie przy montowaniu żeby sprawdzić pozycję początkową
    handleScroll(); 
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <button 
      onClick={scrollToTop} 
      // Dynamiczne przypinanie klas 'show' oraz 'at-bottom'
      className={`pcc-scroll-to-top ${isVisible ? 'show' : ''} ${isAtBottom ? 'at-bottom' : ''}`} 
      aria-label="Wróć na górę"
      title="Wróć na górę"
    >
      <FontAwesomeIcon icon={faChevronUp} />
    </button>
  );
};

export default ScrollToTop;